export default __webpack_public_path__ + "static/rsra-534f7ffaa1112758bbe0daba418a6a95.png";